module.exports = __webpack_public_path__ + "img/download-top-button-icon.437232f2.png";